import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import { voucherTypesMessages } from 'src/features/voucherTypes/utils/messages';
import VoucherTypesTable from 'src/features/voucherTypes/components/tables/VoucherTypesTable';

const VoucherTypesLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(voucherTypesMessages.voucherTypes));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <VoucherTypesTable />;
};

export default VoucherTypesLayout;
